import react, { PureComponent } from 'react';

class FormikSelect extends PureComponent {

    handleChange = (event) => {
        const { name, onChange, options } = this.props;
        const selectedOption = options.find(option => option.value == event.target.value);
  
        onChange(name, ( selectedOption ? selectedOption.value : null));
    }

    renderOptions = () => {
        const { options, placeholder, value } = this.props;
        const opts = [
            placeholder && {
                text: placeholder
            } || null,
            ...options
        ].filter(option => option);
        return opts.map((option, index) => {
            return (
                <option
                    key={index}
                    value={option.value}
                >
                    {option.text}
                </option>
            );
        });
    }

    render() {
        const { name, value, disabled, required } = this.props;
        const requiredAttribute = (required ? 'required="required"' : '');
        
        return (
            <div
                className="umb-property-editor"
            >
                <select
                    disabled={disabled}
                    name={name}
                    onChange={this.handleChange}
                    defaultValue={value !== undefined && value !== null
                        ? value
                        : ''}
                    className="umb-editor umb-dropdown"
                    required
                >
                    {this.renderOptions()}
                </select>
            </div>
        );
    }

}

export default FormikSelect;